import type { Role } from "@/data/experience";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";
import { formatPeriods } from "@/lib/dates";
import { TagList } from "./Tag";

export function ExperienceItem({ role }: { role: Role }) {
  const { locale, t, tList } = useLocale();

  return (
    <article className="grid gap-4 border-t border-border py-8 sm:grid-cols-[11rem_1fr] sm:gap-8">
      <div className="space-y-1">
        <p className="font-mono text-xs text-faint">{formatPeriods(role.periods, locale)}</p>
      </div>

      <div className="space-y-3">
        <div className="space-y-1">
          <h3 className="font-medium tracking-tight">
            {role.company}
            {role.client ? (
              <span className="text-muted">
                {" "}
                — {t(ui.client)}: {role.client}
              </span>
            ) : null}
          </h3>
          <p className="label text-accent">{t(role.title)}</p>
        </div>

        <p className="max-w-2xl text-[15px] leading-relaxed text-muted text-pretty">
          {t(role.summary)}
        </p>

        <ul className="max-w-2xl space-y-2">
          {tList(role.highlights).map((highlight) => (
            <li
              key={highlight}
              className="relative pl-4 text-sm leading-relaxed text-muted text-pretty before:absolute before:left-0 before:top-[0.6em] before:size-1 before:rounded-full before:bg-border-strong"
            >
              {highlight}
            </li>
          ))}
        </ul>

        <TagList items={role.skills} label={`${t(ui.technologiesUsedAt)} ${role.company}`} />
      </div>
    </article>
  );
}
